/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalSearchVaultList } from '../../models/global-search-vault-list';

export interface GlobalSearchGetVaultList$Params {

/**
 * Search text
 */
  searchText: string;
}

export function globalSearchGetVaultList(http: HttpClient, rootUrl: string, params: GlobalSearchGetVaultList$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalSearchVaultList>> {
  const rb = new RequestBuilder(rootUrl, globalSearchGetVaultList.PATH, 'get');
  if (params) {
    rb.query('searchText', params.searchText, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GlobalSearchVaultList>;
    })
  );
}

globalSearchGetVaultList.PATH = '/global-search/vault/list';
